"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgGmailMail = function SvgGmailMail(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 17C1 9.458 1 5.686 3.343 3.343S9.458 1 17 1c7.543 0 11.314 0 13.657 2.343S33 9.458 33 17c0 7.543 0 11.314-2.343 13.657S24.543 33 17 33c-7.542 0-11.314 0-13.657-2.343S1 24.543 1 17Z",
    fill: "#fff",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.805 15.041H26V15h-9v4h5.651A5.998 5.998 0 0 1 11 17a6 6 0 0 1 6-6c1.53 0 2.921.577 3.98 1.52L23.81 9.69A9.954 9.954 0 0 0 17 7C11.477 7 7 11.477 7 17s4.477 10 10 10 10-4.477 10-10c0-.67-.069-1.325-.195-1.959Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.153 12.345 3.286 2.41A5.997 5.997 0 0 1 17 11c1.53 0 2.921.577 3.98 1.52l2.83-2.829A9.954 9.954 0 0 0 17 7a9.994 9.994 0 0 0-8.847 5.345Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 27c2.583 0 4.93-.988 6.704-2.596l-3.095-2.619A5.955 5.955 0 0 1 17 23a5.997 5.997 0 0 1-5.642-3.973l-3.26 2.513C9.751 24.778 13.112 27 17 27Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.805 15.041H26V15h-9v4h5.651a6.02 6.02 0 0 1-2.043 2.785h.002l3.095 2.619C23.485 24.602 27 22 27 17c0-.67-.069-1.325-.195-1.959Z",
    fill: "#1976D2"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgGmailMail);
var _default = exports["default"] = Memo;